module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "fmtitle1"
  }, [_c('a', {
    attrs: {
      "id": "page_5"
    }
  }, [_vm._v("CONTENTS:")])]), _c('a', {
    attrs: {
      "id": "page_5"
    }
  }), _c('p', {
    staticClass: "toct"
  }, [_c('a', {
    attrs: {
      "id": "page_5"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/07_Introduction"
    }
  }, [_c('b', [_vm._v("INTRODUCTION")])])]), _vm._v(" "), _c('p', {
    staticClass: "toct"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/08_Part01"
    }
  }, [_c('b', [_vm._v("PART ONE: The Invention of Old Town")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/09_Chapter01"
    }
  }, [_vm._v("Chapter One: Tower Town and the Gold Coast")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/10_Chapter02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Two: Rehabbing and Redlining")])]), _vm._v(" "), _c('p', {
    staticClass: "toct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_Part02",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("PART TWO: The Conservation of Lincoln Park")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Three: Strict Enforcement")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/13_Chapter04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Four: The Special Situation")])]), _vm._v(" "), _c('p', {
    staticClass: "toct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_Part03",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("PART THREE: The Battle of Lincoln Park")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Chapter05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Five: Project One")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Chapter06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Six: Concerned Citizens")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/17_Chapter07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Seven: The Poor People’s Coalition")])]), _vm._v(" "), _c('p', {
    staticClass: "toct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/18_Conclusion",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("CONCLUSION")])])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Acknowledgement",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("ACKNOWLEDGEMENTS")])])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/20_Bm01",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("SOURCES")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-65287201","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/05_Contents.vue
// module id = 69
// module chunks = 0